import React from 'react'

interface TitleProps {
  title: string;
}

const Title:React.FC<TitleProps> = ({title}) => {
  return (
    <div className="text-sub-header font-bold mb-6 text-gray-800 font-dm-sans sm:mb-4 w-full">{title}</div>
  )
}

export default Title